import { SupportRequestAddItem } from '../types/supportTypes'

const SUBJECT_MIN_LENGTH = 3
const SUBJECT_MAX_LENGTH = 200
const BODY_MAX_LENGTH = 10_000
const SUPPORT_IMAGES_MAX = 5
const SUPPORT_IMAGE_MAX_SIZE_MB = 5
const SUPPORT_IMAGE_ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/webp']

const validateSupportRequestForm = (
  supportRequestForm: SupportRequestAddItem
) => {
  if (!supportRequestForm.reason) {
    return 'Reason is required.'
  }

  const subject = supportRequestForm.subject.trim()

  if (!subject) {
    return 'Subject is required.'
  }

  if (subject.length < SUBJECT_MIN_LENGTH) {
    return `Subject must be at least ${SUBJECT_MIN_LENGTH} characters long.`
  }

  if (subject.length > SUBJECT_MAX_LENGTH) {
    return `Subject must be at most ${SUBJECT_MAX_LENGTH} characters long.`
  }

  const body = supportRequestForm.body.trim()

  if (!body) {
    return 'Details are required.'
  }

  if (body.length > BODY_MAX_LENGTH) {
    return `Details must be at most ${BODY_MAX_LENGTH.toLocaleString()} characters long.`
  }
}

const validateSupportMessageBody = (body: string) => {
  const trimmedBody = body.trim()

  if (!trimmedBody) {
    return 'Message is required.'
  }

  if (trimmedBody.length > BODY_MAX_LENGTH) {
    return `Message must be at most ${BODY_MAX_LENGTH.toLocaleString()} characters long.`
  }
}

const validateSupportImages = (files: File[], currentCount: number) => {
  if (currentCount + files.length > SUPPORT_IMAGES_MAX) {
    return `A support request can have at most ${SUPPORT_IMAGES_MAX} images.`
  }

  if (files.some((file) => !SUPPORT_IMAGE_ACCEPTED_TYPES.includes(file.type))) {
    return 'Only JPEG, PNG and WebP images are allowed.'
  }

  if (
    files.some((file) => file.size > SUPPORT_IMAGE_MAX_SIZE_MB * 1024 * 1024)
  ) {
    return `Each image must be ${SUPPORT_IMAGE_MAX_SIZE_MB} MB or smaller.`
  }
}

export {
  validateSupportRequestForm,
  validateSupportMessageBody,
  validateSupportImages,
  SUPPORT_IMAGES_MAX,
  SUPPORT_IMAGE_MAX_SIZE_MB,
  SUPPORT_IMAGE_ACCEPTED_TYPES,
}
